import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(() => ({
  flagBadge: {
    display: "inline-block",
    borderRadius: "4px",
    padding: "2px 8px",
    fontSize: "0.72rem",
    fontWeight: 600,
    whiteSpace: "nowrap"
  },

  badgeSuccess: {
    backgroundColor: "#e8f5e9",
    color: "#2e7d32"
  },

  badgeFail: {
    backgroundColor: "#fce4ec",
    color: "#c62828"
  },

  badgeNeutral: {
    backgroundColor: "#f5f5f5",
    color: "#757575"
  },

  badgeWarning: {
    backgroundColor: "#fff8e1",
    color: "#f57f17"
  },

  excessoHigh: {
    color: "#c62828",
    fontWeight: 600
  },

  excessoMid: {
    color: "#e65100",
    fontWeight: 600
  },

  excessoLow: {
    color: "#2e7d32",
    fontWeight: 600
  },

  sobraPositive: {
    color: "#c62828",
    fontWeight: 600
  },

  sobraZeroOrNegative: {
    color: "#2e7d32",
    fontWeight: 600
  },

  promoReason: {
    fontSize: "0.72rem",
    color: "#616161",
    fontStyle: "italic",
    display: "block",
    whiteSpace: "normal",
    lineHeight: 1.3,
    maxWidth: "220px"
  }
}));
